export default __webpack_public_path__ + "static/pdf-adab84edcb1e57da776a7747bc95a4f1.svg";